export enum FixedPriceType {
    ftpNo = 0,
    ftpCard = 1,
    ftpContract = 2
}